import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { Pagina } from 'src/app/shared/models/pagina';
import { PaginaService } from 'src/app/shared/services/pagina.service';
import { SeoService } from 'src/app/shared/util/seo.service';
import { PAGE_TITLE } from 'src/globals';

@Component({
  selector: 'app-page-sub',
  templateUrl: './page-sub.component.html',
  styleUrls: ['./page-sub.component.scss'],
})
export class PageSubComponent implements OnInit {
  title = 'Institucional';
  baseURL = '/institucional/';
  // TODO: mudar pra Observable
  paginas: Pagina[];
  pagina: Pagina = new Pagina();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private titleService: Title,
    private paginaService: PaginaService,
    private seo: SeoService
  ) {
    this.titleService.setTitle(`${this.title} - ${PAGE_TITLE}`);
  }

  ngOnInit(): void {
    let slug = this.route.snapshot.paramMap.get('slug');

    this.loadPages(slug);
  }

  loadPages(slug: string) {
    this.paginaService.getPaginas().subscribe(
      result => {
        this.paginas = result;
        if (!slug) {
          if (result?.length > 0) this.router.navigateByUrl(`${this.baseURL}${result[0].slug}`);
        } else {
          let lst = result.filter(x => x.slug == slug);
          if (!lst || lst?.length <= 0) {
            lst = [];
            result.forEach(x => x.filhasAtivas && x.filhasAtivas.forEach(y => lst.push(y)));
            lst = lst.filter(x => x.slug == slug);
          }
          if (!lst || lst?.length <= 0) {
            this.router.navigateByUrl('/home');
            return;
          }
          this.pagina = lst[0];
          this.updateSEO();
        }
      },
      error => {
        // console.error('Erro ao consultar páginas', error);
      }
    );
  }

  updateSEO() {
    // title
    let title = `${this.title} - ${this.pagina.titulo} - ${PAGE_TITLE}`;
    this.titleService.setTitle(title);

    // Adiciona/Atualiza as Tags ao head da pagina
    this.seo.addTitle(title).addDescription(this.pagina.conteudo);
  }
}
